import { TypedForm } from '@bo-client/shared/forms/generic-forms/typedForm.type';

export class StorageModel {
  id: number;
  manufacturer: string;
  deviceTypeName: string;
  usableCapacity: number;
  count: number;
  networkReplaceService: boolean;
  alternatingCurrent: boolean;
  phases: number;
  rotaryCurrent: boolean;
  disconnectionByIsolatedOperation: boolean;
  networkAndDeviceProtection: boolean;
  maStRNumber?: boolean;

  couplingType: StorageCouplingType;
  currentType: StorageCurrentType;
  // Obsolete, durch couplyingType ersetzt
  acCoupling: boolean;
  dcCoupling: boolean;
  storageOperationType: StorageOperationType;
  zerezId?: string;
  zerezIdPAVEProtection?: string;
  zerezIdNaProtection?: string;
  /** `2` = neue Speicher-NA (V2); `1` oder fehlend = Legacy; für persistierte Alt-Daten oft `undefined`/`null`. */
  formVersion?: number;
  /** Energieflussrichtungssensor vorhanden */
  currentFlowDirectionSensor?: boolean;
  // Achtung: Weitere Werte für Speicher können sich im ConsumerModel befinden
  // → Speicher als Verbraucher

  static hasProduction(storageOperationType: StorageModel['storageOperationType']) {
    const productionValues = [
      StorageOperationTypeEnum.CONSUMPTION_PRODUCTION,
      StorageOperationTypeEnum.NO_CONSUMPTION_PRODUCTION
    ];
    return productionValues.some((value) => `${value}` === storageOperationType);
  }
  static hasConsumption(storageOperationType: StorageModel['storageOperationType']) {
    const productionValues = [
      StorageOperationTypeEnum.CONSUMPTION_PRODUCTION,
      StorageOperationTypeEnum.CONSUMPTION_NO_PRODUCTION
    ];
    return productionValues.some((value) => `${value}` === storageOperationType);
  }
  static isAlternatingCurrent(currentType: StorageModel['currentType']) {
    return currentType === `${StorageCurrentTypeEnum.alternatingCurrent}`;
  }
  static isACCouplingType(couplingType: StorageModel['couplingType']) {
    return couplingType === `${StorageCouplingTypeEnum.AC}`;
  }
  static isNDProtection(networkAndDeviceProtection: StorageModel['networkAndDeviceProtection']) {
    return !!networkAndDeviceProtection;
  }
}

export enum StorageOperationTypeEnum {
  NO_CONSUMPTION_NO_PRODUCTION = 'NO_CONSUMPTION_NO_PRODUCTION',
  NO_CONSUMPTION_PRODUCTION = 'NO_CONSUMPTION_PRODUCTION',
  CONSUMPTION_NO_PRODUCTION = 'CONSUMPTION_NO_PRODUCTION',
  CONSUMPTION_PRODUCTION = 'CONSUMPTION_PRODUCTION'
}

export type StorageOperationType = `${StorageOperationTypeEnum}`;

export const StorageOperationTypeDisplayNames: Record<StorageOperationType, string> = {
  [StorageOperationTypeEnum.NO_CONSUMPTION_NO_PRODUCTION]: 'Kein Bezug und keine Einspeisung',
  [StorageOperationTypeEnum.NO_CONSUMPTION_PRODUCTION]: 'Kein Bezug aber Einspeisung',
  [StorageOperationTypeEnum.CONSUMPTION_NO_PRODUCTION]: 'Bezug und keine Einspeisung',
  [StorageOperationTypeEnum.CONSUMPTION_PRODUCTION]: 'Bezug und Einspeisung'
};

export enum StorageCouplingTypeEnum {
  AC = 'AC',
  DC = 'DC'
}

export type StorageCouplingType = `${StorageCouplingTypeEnum}`;

export const StorageCouplingTypeDisplayNames: Record<StorageCouplingType, string> = {
  [StorageCouplingTypeEnum.AC]: 'AC-gekoppelt',
  [StorageCouplingTypeEnum.DC]: 'DC-gekoppelt'
};

export enum StorageCurrentTypeEnum {
  rotaryCurrent = 'rotaryCurrent',
  alternatingCurrent = 'alternatingCurrent'
}

export type StorageCurrentType = `${StorageCurrentTypeEnum}`;

export const StorageCurrentTypeDisplayNames: Record<StorageCurrentType, string> = {
  [StorageCurrentTypeEnum.rotaryCurrent]: 'Drehstrom',
  [StorageCurrentTypeEnum.alternatingCurrent]: 'Wechselstrom'
};

export type StorageForm = TypedForm<
  Omit<StorageModel, 'alternatingCurrent' | 'rotaryCurrent' | 'acCoupling' | 'dcCoupling'>
>;
